module.exports = __webpack_public_path__ + "img/FR19730.2b824a92.png";